import * as React from "react";
import {
  UitkMessagingCard,
  UitkMessagingCardMedia,
  UitkMessagingCardImageLayout,
  UitkMessagingCardSection,
} from "uitk-react-messaging-cards";
import { UitkText } from "uitk-react-text";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { PropertyFilterSearchQuery } from "__generated__/api";
import MessageResult = PropertyFilterSearchQuery.MessageResultInlineFragment;

export const MessagingCard = ({ title, subtitle }: MessageResult) => {
  /* istanbul ignore next */
  const iconDescription = title?.icon?.description;
  /* istanbul ignore next */
  const iconName = title?.icon?.id;
  /* istanbul ignore next */
  const heading = title?.text!;

  return (
    <div role="alert">
      <UitkMessagingCard imageLayout={UitkMessagingCardImageLayout.LEFT}>
        <UitkMessagingCardMedia withBackground={true}>
          {iconName && <UitkIcon description={iconDescription} name={iconName} size={UitkIconSize.MEDIUM} />}
        </UitkMessagingCardMedia>
        <UitkMessagingCardSection heading={heading} headingLevel="h3">
          {subtitle && <UitkText size={300}>{subtitle.text}</UitkText>}
        </UitkMessagingCardSection>
      </UitkMessagingCard>
    </div>
  );
};

export default MessagingCard;
